import styled from 'styled-components';
// eslint-disable-next-line import/prefer-default-export

const colorTheme = {
  secondary: '#1b7bdd',
  red: '#ce445b',
  green: '#1ba39c',
};

export const StatInfo = styled.section`
  padding: 50px 0 0 0;

  @media (max-width: 991px) {
    position: relative;
    z-index: 90;
  }
  @media (max-width: 575.98px) {
    padding: 50px 0 10px;
  }

  ul {
    list-style-type: none;
    margin: 0;
    width: 100%;

    @media (max-width: 1399px) {
      padding: 50px;
    }

    @media (max-width: 1199px) {
      text-align: center;
    }

    @media (max-width: 991px) {
      padding: 0;
    }

    @media (max-width: 767px) {
      flex-flow: column;
      padding: 0 10px;
    }

    @media (max-width: 575px) {
      margin-bottom: 0;
    }

    .slick-track {
      @media (min-width: 767px) {
        margin-left: 0px;
        margin-right: 0px;
        display: flex;
        justify-content: space-between;
        width: 100% !important;
      }
    }

    .slick-prev {
      z-index: 9;
    }

    .slick-dots {
      @media (max-width: 767.98px) {
        padding: 0;
        li {
          width: auto !important;
          padding: 0px;
        }
      }
    }

    &[dir='ltr'] {
      .slick-next {
        right: 0px;
      }

      .slick-prev {
        left: 0px;
      }
    }

    &[dir='rtl'] {
      .slick-next {
        left: 0px;
        transform: translate(0, -50%) rotate(180deg);
      }

      .slick-prev {
        right: 0px;
        transform: translate(0, -50%) rotate(-180deg);
      }
    }

    .list-container {
      padding: 30px 0;
      width: 250px !important;
      margin: 0;

      @media (max-width: 991px) {
        text-align: center;
        width: 100% !important;
      }

      @media (max-width: 767px) {
        width: 100% !important;
      }

      @media (max-width: 575px) {
        padding: 0 0 30px;
      }

      p {
        color: #000;
        margin: 0;
      }

      .num {
        font-size: 48px;
        line-height: 1.2;

        @media (max-width: 1199.98px) {
          font-size: 42px;
        }

        @media (max-width: 991.98px) {
          font-size: 36px;
        }

        @media (max-width: 767.98px) {
          font-size: 48px;
        }

        &[dir='rtl'] {
          font-size: 20px;
          line-height: 27px;

          span {
            font-size: 40px;
            line-height: 48px;
            font-family: GESSTwoDWTCMedium, sans-serif !important;
          }
        }

        &:after {
          display: block;
          content: '';
          position: relative;
          margin: 10px 0;
          width: 100px;
          height: 1px;
          background: ${({ color }) => colorTheme[color]};

          @media (max-width: 1199px) {
            margin: 10px auto;
          }

          @media (max-width: 991px) {
            margin: 11px auto;
          }
        }
      }

      .numtxt {
        line-height: 1.2;
        font-size: 40px;

        small {
          margin-top: 10px;
          display: block;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2.18px;
          padding-left: 2px;
        }

        @media (max-width: 1199px) {
          font-size: 36px;
        }

        @media (max-width: 991.98px) {
          font-size: 30px;
        }

        @media (max-width: 767px) {
          font-size: 40px;
        }

        &[dir='rtl'] {
          font-size: 20px;
          line-height: 27px;

          small {
            font-size: 14px;
            letter-spacing: 0;
            margin-top: 0;
            padding-left: 0px;
          }
        }
      }
    }
  }
`;

export const StatCaption = styled.div`
  position: relative;
  text-align: center;

  .stat-link-wrapper {
    @media (max-width: 991px) {
      margin-top: -100px;
      position: relative;
      margin-bottom: 60px;

      .view_all {
        color: #fff;
      }
      svg.arrow {
        fill: white;
      }
    }

    &[dir='ltr'] {
      text-align: left;
      text-transform: uppercase;
      font-size: 12px;
    }
    &[dir='rtl'] {
      font-size: 14px;
      text-align: right;
    }
  }

  svg.arrow {
    width: 0.875rem;
    fill: black;
  }

  &[dir='ltr'] {
    svg.arrow {
      margin-right: 5px;
      transform: rotate(-180deg);
    }
  }

  &[dir='rtl'] {
    svg.arrow {
      margin-left: 5px;
    }
  }

  h2 {
    color: #4a4a4a;

    @media (max-width: 1200px) {
      font-size: 26px;
      line-height: 30px;
    }

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  &.intro_stat {
    h2 {
      @media (min-width: 992px) {
        width: 767px;
        margin: 0px auto;
      }
    }
  }
`;

export const Span = styled.span`
  font-size: ${({ dir }) => (dir === 'rtl' ? '40px' : '')};
  line-height: ${({ dir }) => (dir === 'rtl' ? '48px' : '')};
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif !important' : '')};
`;

export const NumP = styled.p`
  font-size: ${({ dir }) => (dir === 'rtl' ? '20px!important' : '')};
  line-height: ${({ dir }) => (dir === 'rtl' ? '27px!important' : '')};

  small {
    margin-top: ${({ dir }) => (dir === 'rtl' ? '0px!important' : '')};
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px!important' : '')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0!important' : '')};
  }
`;
